module.exports = __webpack_public_path__ + "img/happy.e11e70ef.jpg";